import { useDistanceToNow } from '@/hooks/useDistanceToNow';

export const useVideoDistanceToNow = (videoDate: string) => {
  const distanceToNow = useDistanceToNow();
  return distanceToNow(videoDate);
};
